import { Component, Input, OnChanges, AfterViewInit,
    EventEmitter, Output, SimpleChanges, ViewEncapsulation, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { Subscription, fromEvent } from 'rxjs';

@Component({
    selector: "gallery",
    templateUrl: "./gallery.component.html",
    styleUrls: ["./gallery.component.scss"],
    encapsulation: ViewEncapsulation.Emulated
})
export class GalleryComponent implements OnChanges, AfterViewInit{
    @Input("control") isHidden:boolean = true;
    @Input("images") images:string[] = [];
    @Input("img") img:string;
    @Output("onClose") onClose:EventEmitter<boolean> = new EventEmitter<boolean>();
    public image:string;
    public currIndex:number;
    public firstIndex:number;
    public isReady:boolean = false;
    public subscription:Subscription;

    constructor(@Inject(PLATFORM_ID) private platformId:Object){}

    ngOnChanges(changes:SimpleChanges){
        if(!this.isHidden){
            this.showImages();
            this.subscription = fromEvent(document, 'keydown').subscribe(ev => {
                switch(ev['key']) { 
                    case 'ArrowLeft': { 
                       this.previousImage(ev);
                       break; 
                    } 
                    case 'ArrowRight': { 
                       this.nextImage(ev);
                       break; 
                    } 
                    case 'Escape': { 
                        this.close();
                        break; 
                     } 
                    default: { 
                       //statements; 
                       break; 
                    } 
                }
            });
        }
    }

    
    ngAfterViewInit() {
        if(!isPlatformServer(this.platformId))
            this.isReady = true;
    }

    ngOnDestroy(): void {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        if(this.subscription)
            this.subscription.unsubscribe();
        
    }

    showImages(){
        this.currIndex = 0;
        if(this.images.length > 0){
            this.firstIndex = this.images.indexOf(this.img);
            if (this.firstIndex > -1) {
                this.currIndex = this.firstIndex;
                this.image = this.images[this.firstIndex];
            } else {
                this.image = this.images[0];
            }
        }
    }

    

    close(){
        this.onClose.emit(true);
        this.subscription.unsubscribe();
    }

    previousImage(event){
        let nextIndex = this.currIndex;
        if(this.currIndex==0){
            nextIndex = this.images.length-1;
        }else{
            nextIndex = this.currIndex-1;
        }
        this.image = this.images[nextIndex];
        this.currIndex = nextIndex;
        event.stopPropagation();
    }

    nextImage(event){
        let nextIndex = this.currIndex;
        if(this.currIndex==this.images.length-1){
            nextIndex = 0;
        }else{
            nextIndex = this.currIndex+1;
        }
        this.image = this.images[nextIndex];
        this.currIndex = nextIndex;
        event.stopPropagation();        
    }

    onEvent(event){
        event.stopPropagation();
    }
}